/**
 * Created by Nagibator on 5/10/2017.
 */
export default function validateLetter (value) {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^(\s|\w)+$/.test(value)
}



// WEBPACK FOOTER //
// ./src/utils/validators/isLetter.js